var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSparkling = function SvgIconSparkling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M12.988 9.89q.096.301.096.613h3.35a1 1 0 0 0-.171-.557l-5.435-8.065a.98.98 0 0 0-.656-.42q.048.007.096.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CCFF",
    d: "m7.012 9.886 2.72-8.41a.98.98 0 0 0-.56.401L3.737 9.942a1 1 0 0 0-.17.557h3.349c0-.207.032-.414.096-.613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M7.013 11.116a2 2 0 0 1-.097-.616h-3.35c0 .195.057.39.171.56l5.435 8.062c.162.24.402.376.656.42q-.048-.006-.096-.02z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0850AC",
    d: "M13.084 10.5c0 .208-.032.416-.097.616l-2.72 8.407q-.046.011-.096.02a.98.98 0 0 0 .657-.421l5.434-8.062a1 1 0 0 0 .17-.56z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E87",
    d: "m10.61 1.878 5.322 8.065c.114.169.17.363.17.557h.331a1 1 0 0 0-.17-.557l-5.435-8.065a.97.97 0 0 0-.558-.394l.034.104c.117.07.222.166.306.29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M16.103 10.5c0 .195-.057.39-.17.56l-5.323 8.062a1 1 0 0 1-.306.29l-.034.104a.97.97 0 0 0 .558-.394l5.435-8.062a1 1 0 0 0 .17-.56z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M6.916 10.501h6.168q0-.312-.097-.613l-2.72-8.41a1.1 1.1 0 0 0-.535 0l-2.72 8.41q-.096.301-.096.613"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#83E2FC",
    d: "M9.891 1.453c-.095.01-.12.018-.16.027L7.013 9.89c-.064.199-.096.406-.096.613h.62q0-.312.096-.613z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M12.987 11.116c.065-.2.097-.408.097-.616H6.916c0 .208.032.416.096.616l2.72 8.407c.161.044.372.045.536 0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3FF",
    d: "M9.891 19.55c-.118-.013-.121-.02-.16-.027l-2.719-8.41a2 2 0 0 1-.096-.613h.62q0 .313.096.613z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00809E",
    d: "m10.27 1.484 2.717 8.403q.097.301.097.613h.423q0-.312-.096-.613z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFF8FF",
    d: "M9.423 1.625a1 1 0 0 0-.251.256L3.737 9.946a1 1 0 0 0-.17.557h.574c0-.194.057-.388.17-.557z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "m10.27 19.516 2.717-8.403a2 2 0 0 0 .097-.613h.423q0 .313-.096.613z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#85D1FF",
    d: "M9.423 19.378a1 1 0 0 1-.251-.256l-5.435-8.065a1 1 0 0 1-.17-.557h.574c0 .194.057.388.17.557z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.735 6.193 10.829 1.88a1.007 1.007 0 0 0-1.657 0L4.211 9.242c4.975.304 7.858-1.18 9.524-3.05",
    opacity: 0.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-sparkling_svg__a)",
    d: "M9.191 8.105a1.74 1.74 0 1 0 0-3.48 1.74 1.74 0 0 0 0 3.48",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-sparkling_svg__b)",
    d: "m9.455 6.502.503.628-.629-.503-.138 1.248-.138-1.248-.63.503.504-.628-1.248-.139 1.248-.138-.503-.629.629.503.138-1.247.138 1.247.63-.503-.504.629 1.248.138z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-sparkling_svg__c)",
    d: "M6.88 14.652c.43.727.892 1.435 1.38 2.105a26.7 26.7 0 0 0-2.558-4.335c.35.752.747 1.498 1.179 2.23"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-sparkling_svg__d)",
    d: "M11.266 16.012a2.318 2.318 0 1 0 0-4.637 2.318 2.318 0 0 0 0 4.637",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-sparkling_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(9.19 6.365)scale(1.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-sparkling_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(9.19 6.363)scale(1.5117)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-sparkling_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.266 13.694)scale(2.31887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-sparkling_svg__c",
    x1: 6.465,
    x2: 5.249,
    y1: 12.902,
    y2: 14.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIconSparkling;